<template>
	<main-page :color="brand.home_color">
		<template v-slot:title>
			<a class="btn btn-login" :href="loginurl">Login</a>
		</template>

		<div class="tall-img position-relative">
			<div class="text-overlay">
				<div class="text-overlay-header si-font">{{brand.home_title}}</div>
				<div class="text-overlay-body mt-3">{{brand.home_text}}</div>
			</div>
			<img class="home-img" :src="brand.login_bg" />
		</div>
		<div v-if="brand.home_promo">
		<div class="full-stripe si-orange text-white">
			<p class="text-2x si-font" style="line-height: 1.2;">
				"Technology in the workplace means workers need the critical thinking and technical skills that come
				with STEM training for a wide variety of careers."
			</p>
			<p class="text-md si-font text-muted mt-2">- "STEM Jobs: 2017 Update," U.S. Department of Commerce</p>
		</div>
		<div class="row">
			<div class="col-6 si-green panel img-panel">
				<img class="img-1" src="@/assets/images/students_puzzle.jpg" />
			</div>
			<div class="col-6 panel text-left">
				<h1 class="mt-0 mb-3 si-font">MEASURABLE RESULTS</h1>
				<p>
					STEM Innovator® provides teachers and their students with interactive and reflective assessment
					tools to measure the impact of engagement in innovation and entrepreneurship on 21st Century Skill
					development over time.
				</p>
			</div>
			<div class="col-6 panel text-left">
				<h1 class="mt-0 mb-3 si-font">PROFESSIONAL DEVELOPMENT</h1>
				<p>
					Join a national cohort of certified STEM Innovator® teachers in rethinking how students gain and
					demonstrate the skills needed in a technologically advancing world. Develop a tailored school
					integration model as you explore curriculum, instruction, and assessment tools aligned to national
					education standards and industry best practices.
				</p>
			</div>
			<div class="col-6 si-blue panel img-panel">
				<img class="img-2" src="@/assets/images/teacher_pd.jpg" />
			</div>
			</div>
		</div>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import BrandService from "@/services/BrandService";
import AuthService from "@/services/AuthService"

export default {
	name: "Home",

	props: [],

	components: { MainPage },

	data() {
		return {
			brand: BrandService.getBrand(),
			app_url: null,

			username: "",
			password: "",

			goingToGoogle: false,

			user: null,
		};
	},

	created() {
		this.loadVersion();
	},

	computed: {
		loginurl() {
			return this.app_url + "/#/login";
		}
	},

	methods: {
		loadVersion() {
			AuthService.getAppUrl()
			.then((r) => {
				this.app_url = r.data
			})
			.catch((e) => {
				console.log(e);
			})
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
	margin-bottom: 0;
}

.tall-img {
	background-image: linear-gradient(
		to right,
		rgba(40, 40, 40) 0%,
		rgba(40, 40, 40) 50%,
		rgba(231, 205, 180) 50%,
		rgba(231, 205, 180) 100%
	);
}

.text-overlay {
	text-align: left;
	position: absolute;
}

@media screen and (min-width: 1733px) {
	.text-overlay {
		left: calc(173px + ((100% - 1733px) / 2));
	}
}

@media screen and (max-width: 561px) {
	.text-overlay {
		left: calc((100% - 392.5px) / 2);
	}
}

.text-overlay-header {
	font-size: 64px;
	font-weight: 600;
	line-height: 1;
	white-space: nowrap;
}

.text-overlay-body {
	font-size: 30px;
	color: white;
}

.login-input {
	background-color: rgba(255, 255, 255, 0.25);
	border: 3px solid black;
	width: 100%;
	padding: 6px;
	font-size: 18px;
	font-weight: 800;
	text-align: center;
}

.panel {
	padding: 4rem;
	font-size: 24px;
}
.img-panel {
	padding: 0;
}

.img-1 {
	width: 100%;
}
.img-2 {
	width: 100%;
}

.google-button {
	position: relative;
}
.google-button-overlay {
	pointer-events: none;
	position: absolute;
	left: 4px;
	right: 4px;
	top: 4px;
	bottom: 4px;
	border-radius: 4px;
	transition: background-color 0.15s, box-shadow 0.15s, -webkit-box-shadow 0.15s, border 0.15s;
	color: white;
}
.google-button:hover .google-button-overlay {
	-webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
	box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
}
.google-button:active .google-button-overlay {
	border: 3px rgb(0, 0, 0, 0.2) solid;
}

.loading-overlay {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: rgba(255, 255, 255, 0.35);
}

.btn-login {
	float: right;
	font-size: 30px;
	margin-top: -5px;
	margin-bottom: -5px;
	margin-right: 30px;
	padding-right: 2rem;
	padding-left: 2rem;
	border: 3px solid black;
	font-family: "Blender Pro";
}
</style>
